// extracted by mini-css-extract-plugin
export var cardIcons = "CardIcons--cardIcons--dJCRV";
export var cardIcons__image = "CardIcons--cardIcons__image--gfCJT";
export var tkMyriadProSemiCondensed = "CardIcons--tk-myriad-pro-semi-condensed--TG5PI";